<template>
  <component   :is="isComponent"></component>
</template>
<script>
import detailsNew from "@/views/course/course_details/detailsNew";
import courseDetails from "@/views/course2/course_details/index";
import { isMain } from '@/utils/tools'
export default {
  data() {
    return {
      isComponent:'',
      bid: ""
    };
  },
  components: {
    detailsNew,
    courseDetails
  },
  methods: {
    /*
     *@param: bid
     *@return:
     *@Description: 根据路由上的bid判断 1 个人战略  2自我探索
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-09-26 14:47:48
     */
    pullData() {
      let querys = this.$route.query;
        if(querys.bid==1){
          this.isComponent = detailsNew;
        }
        if(querys.bid==2){
          // 上线判断
          this.isComponent = courseDetails;
        }
    }
  },
  created() {
    this.pullData();
  }
};
</script>